function init_gemeinde_selection() {
    //var myCookies = document.cookie;
    var selectBox = $('select[name="gemeinden"]');
    //selectBoxWrapper = $('.gemeinde-selection .selectbox-wrapper'),
    //found = myCookies.match(/gemeinden_selected_value=(\d*)/);

    /*
    if ( found != null && found[1] != null ) {
        if( found[1] !== selectBox.val() ){
            selectBox.val(found[1]);
            setCookieValues(selectBox.prop('name'), selectBox.val());
        }
        //selectBoxWrapper.addClass('selected');
    }*/

    selectBox.on('change', function () {
        setCookieValues(selectBox.prop('name'), selectBox.val());
        window.location.href = "/?p=" + selectBox.val();
    });
}

if (document.addEventListener) {
    document.addEventListener("DOMContentLoaded", init_gemeinde_selection, false);
} else {
    window.onload = function () {
        init_gemeinde_selection();
    };
}
